







































//import { db, firestore ,functions } from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes"
import { auth } from "@/scripts/firebase"
import { Component,Mixins } from "vue-property-decorator"
import { ValidationObserver } from 'vee-validate'
import Notice from "@/components/Notice.vue"
import Common from '@/mixins/common';

@Component({
	components: {
		Notice,
	}
})

export default class SignIn extends Mixins(Common) {
	email = '';
	isLoading = false
	notice = {} as NoticeProps;

	async created(){
		console.trace('created')
	}

	destroyed() {
		console.trace('destroyed');
	}

	public async sendPasswordResetMail(){
		const observer = this.$refs.resetPasswordValidationObserver as InstanceType<typeof ValidationObserver>;

		try{
			this.notice = {
				isShow: false,
			}
			
			if(! await observer.validate()){
				return
			}

			this.$store.commit("setLoading",true);
			this.isLoading = true

			await auth.sendPasswordResetEmail(this.email)
			this.notice = {
				message: this.$t('resetPassword.sendEmail') as string,
        isShow: true,
        duration: 0,
				type: {'is-info': true}
      }
      this.email = ''
      observer.reset()
		}catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('resetPassword.error') as string
      
			const errorMessage1 = this.$getErrorMessage(errorCode)
      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){        
        observer.setErrors({
         [errorField]: errorMessage1
        })
      }

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
			}
		}finally{
			this.$store.commit("setLoading",false);
			this.isLoading = false
		}
	}
}
